<template>

    <div class="stage-activity-item"
         :style="{color: stageInfo.config.color, background: stageInfo.config.color, }"
         @click.stop="modalShow()">
        <div class="img">
            <img :src="absolute_preview_url" alt="">
        </div>
        <div class="details">
            <div class="stage">
                <div class="name">
                    {{ stageInfo.config.name }}
                </div>
                <div class="icon">
                    <img :src="stageInfo.slug === 'intro' ? `/images/icons/new/icon-warmup.svg` : `/images/icons/new/icon-${stageInfo.slug}.svg`" alt="">
                </div>
            </div>
            <div class="activity-name">{{ activity.name }}</div>
            <i class="cvico-arrow-right icon-arrow"></i>
        </div>

        <fullscreen-modal v-if="modal.show"
                          :color="stageInfo.config.color"
                          @click.stop.prevent=""
                          @close="modalHide()">

            <template #preview>
<!--                <iframe :style="{height: '100%', width: '100%'}"-->
<!--                        frameborder="0"-->
<!--                        src="http://www.africau.edu/images/default/sample.pdf"></iframe>-->
                <iframe v-if="activity.data?.file && activity.data?.file?.mime === 'application/pdf'"
                        :style="{height: '100%', width: '100%'}"
                        :src="uploads.url( activity.data.file.url ) + '#toolbar=1'"
                        frameborder="0"></iframe>
                <img v-else-if="preview_url" class="img-fluid mb-3"
                     :src="`${preview_url ? uploads.url( preview_url ) : 'https://via.placeholder.com/240x240?text=PREVIEW+NOT+AVAILABLE'}`" alt="">

            </template>

            <template v-if="activity.data.description">
                <h4 :style="{color: stageInfo.config.color}">{{ activity.name }}</h4>
                <markdown-text :content="activity.data.description" />
            </template>

            <template v-if="activity?.data?.student_instructions">
                <h4 :style="{color: stageInfo.config.color}">Instructions</h4>
                <markdown-text :content="activity.data.student_instructions" />
            </template>

            <color-button v-if="activity.data.file"
                          :color="stageInfo.config.color"
                          @click="download()">
                <template #icon>
                    <i class="cvico-arrow-down"></i>
                </template>
                <span class="text-uppercase">Download PDF</span>
            </color-button>

<!--            <pre>{{ activity }}</pre>-->

        </fullscreen-modal>

    </div>
</template>

<script>
import uploads from "@/mixins/uploads";

import FullscreenModal from "@/Components/Canvas2/FullscreenModal";
import ColorButton from "@/Components/Canvas2/ColorButton";
import MarkdownText from "@/Components/Common/MarkdownText";

export default {
    name: "StageActivityItem",
    components: {MarkdownText, ColorButton, FullscreenModal},
    mixins: [uploads],
    props: ['activity', 'stageInfo'],

    data(){
        return {
            modal: {
                show: false,
            },
        };
    },


    computed: {

        absolute_preview_url(){

            let url = 'https://via.placeholder.com/480x480?text=PREVIEW+NOT+AVAILABLE';
            let w = 300;
            let h = 300;

            if( this.options?.width ){
                w = h * parseInt(this.options?.width);
            }

            if( this.preview_url ){
                url = this.uploads.image( this.uploads.url( this.canvas_preview_url ), {w, h} );
            }

            return url;

        },

        canvas_preview_url(){
            if( this.uploaded?.preview_url ) return this.uploaded.preview_url;
            return this.preview_url;
        },

        preview_url(){
            if( this.activity.data?.preview_url ) return this.activity.data?.preview_url;
            if( this.activity.data?.preview_file?.preview_url ) return this.activity.data?.preview_file?.preview_url;
            if( this.activity.data?.file?.preview_url ) return this.activity.data?.file?.preview_url;
            return null;
        },

    },

    methods: {

        modalShow(){
            this.modal.show = true;
        },

        modalHide(){
            this.modal.show = false;
        },

        download(){
            window.open( this.uploads.url( this.activity.data.file.url ), '_blank');
        }

    }

}
</script>

<style lang="scss" scoped>
.stage-activity-item{
    cursor: pointer;
    display: flex;
    flex-direction: column;
    background: white;
    box-shadow: rgba(black, 0.1) 0 2px 4px;
    border-radius: .3rem;
    transition: background .3s, color .3s;
    user-select: none;

    &:not(:hover){
        background: white !important;
    }

    &:hover{
        .details{
            .stage{
                .name{
                    color: white;
                }
            }

            .activity-name{
                color: white;
            }
        }
        .icon-arrow{
            color: white;
            transform: rotateZ(90deg);
        }
    }

    .img{
        img{
            border-radius: .3rem .3rem 0 0;
            width: 100%;
            height: auto;
        }
    }
}
.details{
    padding: 1rem 1rem 3rem;
    position: relative;
    flex-grow: 1;
}

.stage{
    display: flex;
    font-weight: $font-weight-bold;
    justify-content: space-between;
    gap: 1rem;

    .icon{
        max-width: 2rem;

        img{
            width: 100%;
            height: auto;
        }
    }
}

.activity-name{
    font-size: 1.8rem;
    font-weight: $font-weight-bold;
    line-height: 1.2;
    color: $dark;
    padding: 0.5rem 0;
    @media (max-width: 650px) {
        font-size: 1rem;
    }
}

.icon-arrow{
    position: absolute;
    right: .5rem;
    bottom: .3rem;
    height: 2rem;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    transition: transform .3s, color .3s;
}
</style>
